import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace, ListView } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../../util.js';

import { getQueryTradeRecords } from '../../action/investmentAction';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';

function MyBody(props) {
  return (
    <div className="am-list-body my-body">
      <span style={{ display: 'none' }}>you can custom body wrap element</span>
      {props.children}
    </div>
  );
}


var objArr;
let ua=navigator.userAgent.toLowerCase()

/*智投交易记录*/
class TransactionRecord extends Component {
  constructor(props) {
    super(props);
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.state = {
      isLoading:true,
      dataSource: ds.cloneWithRows([]),
      modalFlag:false,
      sValue:["0000"],
      pageIndex:1,
      pageSize:30,
      totalDataArr:[],
      superFundCode:"",
      height:window.winHeight - 88,
      seasons: []
    };
  }
  componentDidMount(){
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    let that = this;
    let dispatch = this.props.dispatch;
    // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
    const hei = window.winHeight - 88;
    // simulate initial Ajax
    // setTimeout(() => {
    //   this.setState({
    //     dataSource: ds.cloneWithRows([]),
    //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
    //     isLoading: false,
    //     height: hei,
    //   });
    // }, 600);
    let data = {
        pageIndex:this.state.pageIndex,
        pageSize:this.state.pageSize,
        superFundCode:this.state.superFundCode,
    }
    dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))
    let _seasons = [].concat(this.state.seasons);
    _seasons.push({
      label: '全部产品',
      value: '0000',
      key:0
    });
    for(let i = 0; i < Util.superFundCodeArr.length; i++) {
      _seasons.push({
        label: Util.superFundNameArr[i],
        value: Util.superFundCodeArr[i],
        key: i - 0 + 1
      })
    }
    this.setState({
      seasons: _seasons
    });
  }
  componentWillMount(){
    let { dispatch } = this.props;
    let that = this;
    let data = {
      superFundCode:"",
      pageIndex:1,
      pageSize:99,
    }
    document.getElementsByTagName('title')[0].innerHTML = "交易记录";
    //dispatch(getSupperFundHome({}, (data) => {}, this))
    //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))
  }
  callbackData(data){
    let totalDataArr = this.state.totalDataArr.concat(data);
    this.state.loadingFlag ? this.setState({loadingFlag:false}) : null;
    if(data.length !== 0){
      let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
      if(data.length < this.state.pageSize){
        this.setState({
          isLoading:0,
          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          pageIndex: this.state.pageIndex+1,
          handleFlag:false,
        })
      }else{
        this.setState({
          isLoading:false,
          pageIndex: this.state.pageIndex+1,
          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          handleFlag:false,
        })
      }
    }else{
      this.setState({
        isLoading:0
      })
    }

    console.log(data,"************")
  }

  onEndReached = (event) => {
    let that = this;
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    console.log('reach end', event);

    this.setState({ isLoading: true });

    let { dispatch } = this.props;
    let dataArr = [];
    let totalDataArr = [];

    // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
    let data = {
        pageIndex:this.state.pageIndex,
        pageSize:this.state.pageSize,
        superFundCode:this.state.superFundCode,
    }
    dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))

  }
  goBack(){
    // let pathName = this.props.location.state.pathName? this.props.location.state.pathName :'/';
    // let data = this.props.location.state.data ? this.props.location.state.data : null;
    // hashHistory.push({
    //     pathname:pathName,
    //     state:{
          
    //     }
    // })
    hashHistory.go(-1)
  }


  goTransactionDetail(item){
    let data = {
      businessType:item.businessType,
      tradeRequestId:item.tradeRequestId
    }
    if(item.businessType == "TC24") {
      hashHistory.push({
        pathname:'/Servicechargerecord',
        state:{
          businessType:item.businessType,
          tradeRequestId:item.tradeRequestId
        }
      })
    }else {
      hashHistory.push({
        pathname:'/TransactionDetail',
        state:{
          data,
          flag:"JL",
          commission: item.commission
        }
      })
    }
  }

  onOk(e){
    let fundCode = e[0];
    let that = this;
    let { dispatch } = this.props;
    let flag;
    if(this.state.totalDataArr.length !== 0){
      flag = true;
    }else{
      flag = false;
    }
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    this.setState({
      productAll:false,
      superFundCode:fundCode,
      sValue:e,
      pageIndex:1,
      pageSize:30,
      dataSource: ds.cloneWithRows([]),
      totalDataArr:[],
      loadingFlag:flag,
      handleFlag:true
    })
    let data = {
      pageIndex:1,
      pageSize:30,
      superFundCode:fundCode
    };
    
    console.log(data)

    dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))

    // this.setState({ sValue:e })
    // let data = {
    //   superFundCode:e[0],
    //   pageIndex:1,
    //   pageSize:30,
    // }
    // if(e[0] === "0000"){
    //   data.superFundCode = ""
    // }
    // dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),this))

  }
  renderFooter(){
    console.log("有无加载",this.state.isLoading)
    if(this.state.isLoading === true){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          正在加载...
        </div>
      )
    }else if(this.state.isLoading === false){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          加载完成            
        </div>
      )
    }else if(this.state.isLoading === 0){
      return(
        <div style={{ height: 0, textAlign: 'center' }}>
          没有更多数据了
       </div>
      )
    }
  }
  render() {
    let data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
    // let { SupperFundHome } = this.props;

    // let SuperList = SupperFundHome&&SupperFundHome.singleSuperFundViews ? SupperFundHome.singleSuperFundViews : [];
   
    // let seasons = [
    //   {
    //     label: '全部产品',
    //     value: '0000',
    //     key:0
    //   },
    // ];
    // SuperList.map((item,i)=>{
    //   seasons.push({
    //     label:item.superFundName,
    //     value:item.superFundCode,
    //     key:i+1
    //   })
    // })

    let tempData = [{businessTime:"0000"}];
    tempData = tempData.concat(data);

    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex:1}}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center',fontSize:"0.3rem" }}>交易记录</div>
            <div style={{ WebkitFlex:1, textAlign:'right',fontSize:"0.28rem"}}></div>    
          </div>
          </NavigatorMain>

          {/*
          <div className="chooseBottom">
            <span>全部产品</span><span></span>
          </div>*/}
           <div className={ua.indexOf("amcfmapp")>-1?"chooseSelect_Wrap chooseSelect_Wrap2":"chooseSelect_Wrap"} style={{ position:'fixed',background:"#000", top:44, left:0 }}>
              <Picker data={this.state.seasons} cols={1} className="forss" title="选择产品" value={this.state.sValue}  onPickerChange={e => console.log('onPickerChange', e)} onOk={(e)=>{ this.onOk(e) } } >
                <List.Item></List.Item>
              </Picker>
              <div  className="rightBottomArrow" style={{position:'absolute',right:'0.36rem', top:"50%", zIndex:2}}></div>
          </div>

          <div className='content' style={{ paddingTop:88, }}>

          <ListView
              ref={el => this.lv = el}
              dataSource={this.state.dataSource}
              renderFooter={()=> this.renderFooter() }
              renderBodyComponent={() => <MyBody />}
              renderRow={(rowData, sectionID, rowID) => {
                objArr = [{createDate: ""}].concat(this.state.totalDataArr);
                return(
                <div key ={ rowID } >
                  {
                    returnDateStr(rowData.businessTime) === returnDateStr(objArr[rowID].businessTime) ? null :

                    <div style={{paddingLeft:13,paddingRight:13,paddingTop:22,paddingBottom:12,fontSize:"20px",background:"rgba(242,245,247,1)" }} >
                      { rowData.businessTime.substr(0,7) }
                    </div>
                  }
                  <div className="superListJ" onClick={ ()=> this.goTransactionDetail(rowData) }  style={{ marginBottom:0 }}>
                    <div style={{ borderBottom:'1px solid #f2f4f7'}}>
                      <span style={{ color:'#fa063a'}}>
                        { rowData.businessTypeName }
                      </span>
                      <span></span>
                    </div>
                    <div><span>{ rowData.fundName }</span><span>{getNum(rowData.applicationAmount,rowData.applicationVolume)}</span></div>
                    <div><span>{ rowData.businessStateName }</span><span>{  Util.formatStr(rowData.businessTime) }</span></div>
                  </div>
                  <div style={{ height:10, background:"rgba(242,245,247,1)" }}>
                    
                  </div>

              </div>
              )
              }

              }
              
              style={{
                height: this.state.height,
                overflow: 'auto',
              }}
              pageSize={4}
              onScroll={() => { console.log('scroll'); }}
              scrollRenderAheadDistance={500}
              onEndReached={this.onEndReached}
              onEndReachedThreshold={15}
            />

                  
          {/*
            data.map((item,i)=>{
              let index = i;
              return(
                <div key = { i }>
                  {
                    tempData[index].businessTime.substr(0,7) != item.businessTime.substr(0,7) ?  <div style={{height:"1rem",paddingTop:"0.32rem",paddingLeft:'13px', fontSize:'0.36rem', color:'#3a3e47', fontWeight:'800'}}>{ item.businessTime.substr(0,7) }</div> :null
                  }
                  <div className="superListJ" key = { i } onClick={ ()=> this.goTransactionDetail(item) } >
                    <div style={{ borderBottom:'1px solid #f2f4f7'}}>
                      <span style={{ color:'#fa063a'}}>
                        { item.businessTypeName }
                      </span>
                      <span></span>
                    </div>
                    <div><span>{ item.fundName }</span><span>{ Util.fomatFloat(item.applicationAmount) + "元" }</span></div>
                    <div><span>{ item.businessStateName }</span><span>{  Util.formatStr(item.businessTime) }</span></div>
                  </div>
                </div>
              )
            })
          */}
          {/* 
            this.state.totalDataArr.length === 0 ? <div style={{textAlign:'center',paddingTop:'2rem',color:"rgb(161, 167, 178)"}}>没有相关数据</div> : null 
          
          */}

          {/*
          <div className="superListJ" onClick={ ()=> this.goTransactionDetail() } >
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>锐意进取型</span><span></span></div>
            <div><span>当前资产</span><span>401.14</span></div>
            <div><span>最新收益</span><span>401.14</span></div>
          </div>
          
          <div className="superListJ">
            <div style={{ borderBottom:'1px solid #f2f4f7'}}><span style={{ color:'#fa063a'}}>锐意进取型</span><span></span></div>
            <div><span>当前资产</span><span>401.14</span></div>
            <div><span>最新收益</span><span>401.14</span></div>
          </div>*/}
  

          </div>
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords,
    SupperFundHome:state.SupperFundHome,
  }
}

function returnDateStr(str){
  if(str){
    return str.substr(0,7)
  }
}

export default connect(mapStateToProps)(TransactionRecord);

function getNum(num1,num2){
  if((num1 === "" || num1 === null || num1 === undefined) && (num2 === "" || num2 === null || num2 === undefined)) {
    return "--";
  }
  if(num1 === "" || num1 === null || num1 === undefined) {
    return num2 + '份';
  }
  if(num2 === "" || num2 === null || num2 === undefined) {
    return num1 + '元';
  }
  if(num1 === 0) {
    return num2 + '份';
  }
  if(num2 === 0) {
    return num1 + '元';
  }
  if(num1 === num2) {
    return num1 + '元';
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/TransactionRecord.js